import { useTranslation } from "react-i18next";

function DetectorsByParking(props)
{
  const { t } = useTranslation("common");
  return(
    <div>
    {t('detectorl.source')}
    </div>
  );
};
export default DetectorsByParking;
